<template>
    <v-layout wrap>
        <v-flex xs12 sm5 v-if="options.includes('semester')">
            <v-select append-icon="date_range" label="Semestre" single-line hide-details v-model="filters.semester"
                :items="semesters" item-text="name" item-value="id"></v-select></v-flex>
        <v-flex xs12 sm5 offset-sm1 v-if="options.includes('status')">
            <v-select append-icon="bookmark" label="Situação" single-line hide-details v-model="filters.status"
                :items="statuses" item-text="name" item-value="id"></v-select></v-flex>
        <v-flex xs12 sm5 v-if="options.includes('view')">
            <v-select append-icon="group_work" label="Filtro" single-line hide-details v-model="filters.view"
                :items="viewItems"></v-select></v-flex>
        <v-flex xs12 sm5 offset-sm1 v-if="options.includes('course')">
            <v-select append-icon="class" label="Curso" single-line hide-details v-model="filters.course"
                :items="userCourses" item-text="name" item-value="id"></v-select></v-flex>
        <v-flex xs12 sm5 offset-sm6 v-if="options.includes('type')">
            <v-select append-icon="create" label="Tipo" single-line hide-details v-model="filters.type"
                :items="userTypes" item-text="name" item-value="id"></v-select></v-flex>
        <v-flex xs12 sm5 offset-sm6 v-if="options.includes('enrolled')">
            <v-select append-icon="assignment_turned_in" label="Inscrição" single-line hide-details
                v-model="filters.enrolled" :items="enrolledItems" item-text="name" item-value="id"
                v-if="authenticated"></v-select></v-flex>
    </v-layout>
</template>

<script>
import auth from './../auth'

export default {
    name: 'ExamFilters',
    props: {
        value: Object,
        options: {
            default: function () { return 'type,course,semester,status,view'.split(',') },
            type: Array
        },
        /* Obriga que semestre seja informados */
        semesterRequired: {
            default: false,
            type: Boolean
        },
        courseRequired: {
            default: false,
            type: Boolean
        },
        canSelectAnyCourse: {
            default: false,
            type: Boolean
        },
        /* Exibe o semestre 2017.2 para consulta (apenas interno) */
        showDevSemester: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            examTypes: [],
            courses: [],
            filters: {
                type: '',
                course: '',
                semester: '',
                status: '',
                view: 'view_all',
                enrolled: ''
            }
        }
    },
    computed: {
        userTypes: function () {
            let types = [
                { id: '', name: 'Todos os tipos' }
            ]
            for (let type of this.examTypes) {
                let hasCommonCourse = false
                for (let typeCourse of type.courses) {
                    if (!this.authenticated
                        || auth.user.courses.length == 0
                        || auth.user.roles.includes('admin')
                        || auth.user.courses.includes(typeCourse)) {
                        hasCommonCourse = true
                        break
                    }
                }
                if (hasCommonCourse &&
                    (this.filters.course == '' || type.courses.includes(this.course))) {
                    types.push(type)
                }
            }
            return types
        },
        userCourses: function () {
            let courses = []
            if (!this.courseRequired) {
                courses.push({ id: '', name: 'Todos os cursos' })
            }
            for (let course of this.courses) {
                if (this.canSelectAnyCourse
                    || (this.authenticated &&
                        (auth.user.courses.length == 0
                            || auth.user.roles.includes('admin')
                            || auth.user.courses.includes(course.id))
                    )) {
                    courses.push(course)
                }
            }
            return courses
        },
        currentSemester: function () {
            let currentYear = new Date().getFullYear(),
                currentSemester = new Date().getMonth() <= 6 ? 1 : 2
            return currentYear + '' + currentSemester
        },
        semesters: function () {
            let
                semesters = [],
                currentYear = new Date().getFullYear(),
                currentSemester = new Date().getMonth() <= 6 ? 1 : 2;

            /*
            if (this.showDevSemester) {
                semesters.push({ id: '20172', name: '2017.2'})
            }
            */
            /*
            for (let year = 2017; year <= currentYear; year++) {
                semesters.push({ id: year + '1', name: year + '.1'})
                if (year < currentYear || currentSemester == 2) {
                    semesters.push({ id: year + '2', name: year + '.2'})
                }
            }
            */

            /*
            for (let x = 1; x <= 2; x++) {
                semesters.push({ id: (String(currentYear) + x), name: (currentYear +'.'+ x)})
            }
            */

            //semesters.push({ id: (String(currentYear) + 1), name: (currentYear +'.'+ 1)})

            for (let year = 2017; year <= currentYear; year++) {
                semesters.push({ id: year + '1', name: year + '.1' })
                if (year < currentYear || currentSemester == 2) {
                    semesters.push({ id: year + '2', name: year + '.2' })
                }
            }

            semesters.reverse()
            semesters.unshift({ id: '', name: 'Todos os semestres' })

            return semesters
        },
        statuses: function () {
            return [
                { id: '', name: 'Todas as situações' },
                { id: 'pending', name: 'Pendentes' },
                { id: 'finished', name: 'Finalizadas' },
                { id: 'record_attendance_pending', name: 'Registro de presença pendente' },
                { id: 'certification_pending', name: 'Certificação pendente' },
                { id: 'minutes_pending', name: 'Ata pendente' }
            ]
        },
        viewItems: function () {
            return [
                { value: 'view_all', text: 'Visualizar bancas do meu curso' },
                { value: 'only_mine', text: 'Visualizar bancas que participo' }
            ]
        },
        enrolledItems: function () {
            return [
                { id: '', name: 'Inscrição pendente ou realizada' },
                { id: 'yes', name: 'Inscrição realizada' },
                { id: 'no', name: 'Inscrição não realizada' },
            ]
        },
        authenticated: function () {
            return auth.user.authenticated
        }
    },
    watch: {
        filters: {
            handler() {
                this.$emit('input', this.filters)
            },
            deep: true
        }
    },
    created: function () {
        // Set filters initial value
        console.log(this.filters)
        if (typeof this.value == 'object') {
            for (let key in this.filters) {
                if (typeof this.value[key] !== 'undefined') {
                    this.filters[key] = this.value[key]
                }
            }
        }
        this.$emit('input', this.filters)
        // Load courses
        this.$http.get('courses').then(response => {
            this.courses = response.body;
    
            // Add Todos ao início do filtro
            this.courses.unshift({id: "", name: "Todos", slug: "Todos"});

            // If an initial course is set, check if it is a course slug and substitute it by the corresponding id                
            if (this.filters.course) {
                let initCourse = this.filters.course
                let courseExists = false
                for (let course of this.courses) {
                    if (initCourse == course.id || initCourse == course.slug) {
                        this.filters.course = course.id
                        courseExists = true
                        break
                    }
                }
                if (!courseExists) {
                    console.error('O curso informado na requisição não foi encontrado.')
                    this.filters.course = ''
                }
            } else {
                if (this.courseRequired && !this.filters.course && this.canSelectAnyCourse && this.courses.length > 0) {
                    this.filters.course = this.courses[0].id
                }                    
            }


        }, response => {
            console.error('Erro ao buscar relação de cursos.')
            console.debug(response)
        });            
        // Load types
        this.$http.post('examTypes', { limit: 99999 }).then(response => {
            this.examTypes = response.data.types
        }, response => {
            console.error('Erro ao buscar relação de tipos de banca.')
            console.debug(response)
        }); 

        if (this.semesterRequired) {
            this.filters.semester = this.currentSemester
        }
    }
}

</script>

<style></style>


// WEBPACK FOOTER //
// ExamFilters.vue?c7087cee